import { useSelector } from 'react-redux';
import loupe from '../loupe.png';
import { BASE_APP_URL, BASE_URL, SUBSCRIPTION_PATH } from '../utility/path';
import { useNavigate } from 'react-router-dom';
import { isMobile } from '../services/functions';
import "../CustomLogo.css";
import ActivitySignalBanner from "../components/ActivitySignalBanner";

const CustomLogo = ({ users }) => {
  const navigate = useNavigate();
  const authData = useSelector(state => state?.auth?.data);

  const rawData = localStorage.getItem('init');
  const parsedData = JSON.parse(rawData);
  const cta = parsedData?.cta;
  
  const handleClick = async (event) => {
    if (event) event.preventDefault(); // Ensure event exists before calling preventDefault()
      
    navigate(SUBSCRIPTION_PATH);
    // if (isMobile() && typeof cordova !== "undefined" && cordova?.InAppBrowser) {
    //   //cordova.InAppBrowser.open(`${BASE_APP_URL}?r=${SUBSCRIPTION_PATH}`, "_system");
    //   navigate(SUBSCRIPTION_PATH);
    // } else {
    //   navigate(SUBSCRIPTION_PATH);
    // }
  } 

  return (
    <>
     {/* Inactive account banner */}
      {authData?.isLoggedIn && authData?.role === 'producer' && !authData?.subscribed &&
        <div className="lp-banner" onClick={handleClick}>
          <p className="lp-banner__text">
           <i className="fa fa-exclamation-circle lp-banner__icon" /> Your account is inactive.{" "} <strong>Subscribe to activate →</strong>
          </p>
        </div>
      }

      <h1 className='m-0'>
        Gaufi<span style={{"color":"red"}}>.</span>
        {/* <span className="overlap-container">
          <img src={loupe} className="loupe-image" alt="Loupe" />
          <span className="overlap-i">i</span>
        </span> */}
      </h1>
      <small className="">Find skilled professionals near you</small>
      <p><small className='rounded' style={{
        "padding": "5px", "margin": "5px", "fontSize":"12px",
        "background": "whitesmoke"
      }}>🌟 India's go-to local service app</small></p>
      {cta?.feature && <div className="cta-bar col-md-6 offset-md-3">
        <div className="cta-bar-text">{cta?.txt1 ? cta?.txt1 : "Book any service in under"}<br />{cta?.txt2 ? cta?.txt2 : "6 minutes"} &rarr; {cta?.txt3 ? cta?.txt3 : "free"}</div>
      </div>}
      {/* <ActivitySignalBanner></ActivitySignalBanner> */}
    </>
  );
}

export default CustomLogo;

